import { createStore } from 'vuex'
import moment from 'moment'
// import axios from 'axios'

export default createStore({
  state: {
    cartNum: 0, //* header 購物車數量
    checkoutCart: {
      items: [],
      payInfo: {},
      activities: [],
      orderGifts: []
    }, //* 購物車資訊
    isLogin: false,
    checkInfo: [], //* 將訂單資訊暫存，避免返回頁面重新KEYIN
    isClickCart: false, //* 是否點擊購物車icon
    loginState: 'login',
    cartCalculate: {}
  },
  mutations: {
    getcartNum (state, allProductNum) {
      state.cartNum = allProductNum
    },
    getCheckoutCartInfo (state, CartInfo) {
      state.checkoutCart = CartInfo
    },
    changeLoginState (state, LoginState) {
      state.isLogin = LoginState
    },
    getCheckInfo (state, checkOrder) {
      state.checkInfo = checkOrder
    },
    refreshClickCart (state, clickCart) {
      state.isClickCart = clickCart
    },
    refreshloginState (state, clickLogin) {
      state.loginState = clickLogin
    },
    getCartCalculate (state, cart) {
      state.cartCalculate = cart
    }
  },
  actions: {
    loginSetCookie (context, payload) {
      const cookieToken = payload
      // ? token 存進 localStorage 內
      localStorage.setItem('papaTK', cookieToken.memberAccessToken)
      const deadline = moment().add(cookieToken.tokenAccessExpiredSeconds - 100, 'seconds').format('YYYY/MM/DD HH:mm:ss')
      localStorage.setItem('papaTKExpire', deadline)
    }
  }
})
